/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createTheme, ThemeProvider } from '@material-ui/core/styles';
import { CircularProgress, Paper, Tabs, Tab, Typography, Button } from '@material-ui/core'

import Actions from '../../../fluid/Actions/ActionFactory'
import SetFieldMap from './SetFieldMap';

const blue_theme = createTheme({
  palette: {
      primary: {
        main: '#2296f3',
      },
      secondary: {
        main: "#dc004e",
      },
  },
})


const styles = theme => ({

})

const clone = require("rfdc")();

class SetFieldMaps extends Component {
  state = {
    iu_maps_loading : false,
    iu_maps : null,
    iu_maps_loading_err : null,
    iu_maps_schema : null,
    ic_data : null,
    cur_tab : 0,
    selected_destination_field : null,
    selected_source_field : null,
    submitting_maps : false
  }

  componentDidMount () {
    this.setState({...this.state, iu_maps_loading: true, iu_maps_loading_err : null}, () => {
      Actions('http_request', {
        url : "/sainapse/workflow/" + this.props.wf_name + "/information_unit_field_mapping_schema",
        method : 'get',
        data : {}
      }).then(res => {
        this.setState({...this.state, iu_maps_schema : res.data.result}, () => {
          Actions('http_request', {
            url : '/sainapse/information_channel/' + this.props.ic_name,
            method : 'get',
            data : {}
          }).then(res => {
            let ic_data = res.data.result
            let iu_maps = this.state.iu_maps_schema.map(map => {
              let field_map = {
                destinationIU : map.destinationIU,
                sourceIU :map.sourceIU,
                name : map.name,
                fieldMap : []
              }
              let destination_fields = ic_data.information_units.find(iu => iu.name === map.destinationIU).fields_in_scope
              field_map.fieldMap = destination_fields.map(field => {
                return {
                  destination : field.name,
                  recordLevelAttachment : {
                    allowed_file_extensions : [],
                    attachment_enabled : false,
                    include_attachment_extract : true
                  },
                  source : []
                }
              })

              return field_map
            })

            this.setState({...this.state, 
              ic_data : ic_data, 
              iu_maps : iu_maps, 
              iu_maps_loading : false, 
              iu_maps_loading_err: null
            }, () => console.log("IU Maps State : ", this.state))
          })
        })
      })
    })
  }

  renderMapTabs = () => {
    return (
      <Paper square>
        <Tabs
          value={this.state.cur_tab}
          indicatorColor="primary"
          textColor="primary"
          onChange = {(event, newValue) => this.setState({...this.state, cur_tab : newValue, selected_destination_field : null, selected_source_field : null})}
        >
          {this.state.iu_maps_schema.map(map => {
            return (
              <Tab label = {map.name}/>
            )
          })}
        </Tabs>
      </Paper>
    )
  }

  renderMaps = () => {
    return(
      <SetFieldMap
        iu_maps_schema = {this.state.iu_maps_schema}
        cur_tab = {this.state.cur_tab}
        ic_data = {this.state.ic_data}
        iu_maps = {this.state.iu_maps}
        selected_destination_field = {this.state.selected_destination_field}
        selected_source_field = {this.state.selected_source_field}
        maxHeight = {this.props.maxHeight - 70}
        select_destination_field = {(field_name) => this.selectDestinationField(field_name)}
        select_source_field = {(field_name) => this.selectSourceField(field_name)}
        set_source_fields = {(value) => this.setSourceFields(value)}
        set_global_attachment_state = {(key, value) => this.setGlobalAttachmentState(key, value)}
        set_source_setting = {(key, value) => this.setSourceSetting(key, value)}
        set_source_attachment_setting = {(key, value) => this.setSourceAttachmentSetting(key, value)}
      />
    )
  }

  selectDestinationField = (field_name) => {
    this.setState({...this.state, selected_destination_field : field_name, selected_source_field : null})
  }

  selectSourceField = (field_name) => {
    this.setState({...this.state, selected_source_field : field_name})
  }

  setSourceFields = (fields) => {
    let new_state = clone(this.state)
    let iu_maps = new_state.iu_maps
    let cur_iu_map = iu_maps[this.state.cur_tab]
    let field_maps = cur_iu_map.fieldMap
    let cur_field_map = field_maps[field_maps.findIndex(field_map => field_map.destination === this.state.selected_destination_field)]
    cur_field_map.source = fields
    this.setState({...new_state}, () => console.log("Update IU Maps State : ", this.state.iu_maps))
  }

  setGlobalAttachmentState = (key, value) => {
    let new_state = clone(this.state)
    let iu_maps = new_state.iu_maps
    let cur_iu_map = iu_maps[this.state.cur_tab]
    let field_maps = cur_iu_map.fieldMap
    let cur_field_map = field_maps[field_maps.findIndex(field_map => field_map.destination === this.state.selected_destination_field)]
    cur_field_map.recordLevelAttachment[key] = value
    this.setState({...new_state}, () => console.log("Update IU Maps State : ", this.state.iu_maps))
  }

  setSourceSetting = (key, value) => {
    let new_state = clone(this.state)
    let iu_maps = new_state.iu_maps
    let cur_iu_map = iu_maps[this.state.cur_tab]
    let field_maps = cur_iu_map.fieldMap
    let cur_field_map = field_maps[field_maps.findIndex(field_map => field_map.destination === this.state.selected_destination_field)]
    let source_setting = cur_field_map.source[cur_field_map.source.findIndex(source => source.name === this.state.selected_source_field)]

    source_setting[key] = value

    this.setState({...new_state}, () => console.log("Update IU Maps State : ", this.state.iu_maps))
  }

  setSourceAttachmentSetting = (key, value) => {
    let new_state = clone(this.state)
    let iu_maps = new_state.iu_maps
    let cur_iu_map = iu_maps[this.state.cur_tab]
    let field_maps = cur_iu_map.fieldMap
    let cur_field_map = field_maps[field_maps.findIndex(field_map => field_map.destination === this.state.selected_destination_field)]
    let source_setting = cur_field_map.source[cur_field_map.source.findIndex(source => source.name === this.state.selected_source_field)]

    source_setting.field_attachment_filter[key] = value

    this.setState({...new_state}, () => console.log("Update IU Maps State : ", this.state.iu_maps))
  }

  submitIUMaps = () => {
    this.setState({...this.state, submitting_maps : true}, () => {
      Actions("http_request", {
        url : "/sainapse/workflow/" + this.props.wf_name + "/information_unit_field_mapping",
        method : "post",
        data : this.state.iu_maps
      }).then(res => {
        this.setState({...this.state, submitting_maps : false}, () => this.props.handleNext())
      })
    })
  }

  renderHeading = () => {
    return (
      <div style = {{width : '100%', height : '50px', padding : '10px', borderBottom : '1px solid rgba(0,0,0,0.12)', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
        <Typography style = {{flexGrow : 1}} variant = 'h6'>Set Field maps</Typography>
        <Button
          variant = 'contained'
          color ='primary'
          size = 'small'
          startIcon = {this.state.submitting_maps && <CircularProgress style = {{color : '#FFFFFF'}} variant = 'indeterminate' size = {20}/>}
          onClick = {this.submitIUMaps}
        >Submit</Button>
      </div>
    )
  }

  renderContent = () => {
    if (this.state.iu_maps === null) {
      if (this.state.iu_maps_loading) {
        return (
          <div style = {{width : "100%", height : this.props.maxHeight + 'px', display : 'flex', flexDirection : 'row', alignItems : 'center', justifyContent : 'center'}}>
            <CircularProgress color = "primary" variant = "determinate" />
          </div>
        )
      }
    } else {
      if (this.state.iu_maps_schema.length > 0) {
        return (
          <div style = {{width : "100%", height : (this.props.maxHeight - 180) + 'px'}}>
            {this.renderHeading()}
            {this.renderMapTabs()}
            {this.renderMaps()}
          </div>
        )
      } else {
        return (
          <div
            style = {{
              width : "100%", 
              height : (this.props.maxHeight - 180) + 'px',
              display : 'flex',
              flexDirection : 'column',
              alignItems : 'center',
              justifyContent : 'center'
            }}
          >
            <Typography variant='caption' color='textSecondary'>No IU Maps needed for this WF.</Typography>
            <Button
              variant = 'contained'
              color ='primary'
              size = 'small'
              onClick = {this.props.handleNext}
            >Skip</Button>
          </div>
        )
      }
    }
  }
  render() { 
    return (
      <ThemeProvider theme = {blue_theme}>
        <Paper elevation = {0} square style = {{width : '100%', height : this.props.maxHeight + 'px', overflow : 'scroll'}}>
          {this.renderContent()}
        </Paper>
      </ThemeProvider>
    );
  }
}
 
export default withStyles(styles)(SetFieldMaps);